export default __webpack_public_path__ + "static/media/enhance-3.8cfe7d13.png";